import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  color?: 'magenta' | 'cyan' | 'lime' | 'orange' | 'navy' | 'white';
  withArrow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  color = 'magenta',
  withArrow = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed uppercase tracking-wide';
  const sizeStyles = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base'
  };
  const colorMap = {
    magenta: {
      bg: 'bg-brand-magenta',
      text: 'text-white',
      border: 'border-brand-magenta',
      hover: 'hover:bg-brand-magenta/90',
      ring: 'focus:ring-brand-magenta',
      textColor: 'text-brand-magenta'
    },
    cyan: {
      bg: 'bg-brand-cyan',
      text: 'text-brand-navy',
      border: 'border-brand-cyan',
      hover: 'hover:bg-brand-cyan/90',
      ring: 'focus:ring-brand-cyan',
      textColor: 'text-brand-cyan'
    },
    lime: {
      bg: 'bg-brand-lime',
      text: 'text-brand-navy',
      border: 'border-brand-lime',
      hover: 'hover:bg-brand-lime/90',
      ring: 'focus:ring-brand-lime',
      textColor: 'text-brand-lime'
    },
    orange: {
      bg: 'bg-brand-orange',
      text: 'text-white',
      border: 'border-brand-orange',
      hover: 'hover:bg-brand-orange/90',
      ring: 'focus:ring-brand-orange',
      textColor: 'text-brand-orange'
    },
    navy: {
      bg: 'bg-brand-navy',
      text: 'text-white',
      border: 'border-brand-navy',
      hover: 'hover:bg-brand-navy/90',
      ring: 'focus:ring-brand-navy',
      textColor: 'text-brand-navy'
    },
    white: {
      bg: 'bg-white',
      text: 'text-brand-navy',
      border: 'border-white',
      hover: 'hover:bg-gray-100',
      ring: 'focus:ring-white',
      textColor: 'text-white'
    }
  };
  const selectedColor = colorMap[color];
  const variants = {
    primary: `${selectedColor.bg} ${selectedColor.text} ${selectedColor.hover} shadow-md hover:shadow-lg hover:-translate-y-0.5`,
    secondary: `bg-transparent ${selectedColor.textColor} hover:bg-gray-50`,
    outline: `bg-transparent border-2 ${selectedColor.border} ${selectedColor.textColor} hover:bg-gray-50`,
    ghost: `bg-transparent ${selectedColor.textColor} hover:bg-gray-100/10`
  };
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${sizeStyles[size]} ${variants[variant]} ${selectedColor.ring} ${className}`} {...props} data-id="element-172">
      {children}
      {withArrow && <ArrowRight className="ml-2 h-4 w-4" data-id="element-173" />}
    </motion.button>;
}